<div class="h-full bg-primary-container">
  <div class="mx-auto max-w-7xl p-4 md:p-6 lg:p-8 space-y-6">
    <!-- Header Section -->
    <header class="flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div>
        <div class="flex items-center gap-2 text-sm text-on-surface-variant mb-1">
          <button matIconButton (click)="goBack()" aria-label="戻る">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <span>{{ siteDetail()?.organizationId }}</span>
          <mat-icon class="text-[16px] w-4 h-4">chevron_right</mat-icon>
          <span>傾斜詳細</span>
        </div>
        <h1 class="text-2xl font-bold text-on-surface m-0">
          {{ siteDetail()?.name || '読み込み中...' }}
        </h1>
        <p class="text-sm text-on-surface-variant mt-1">
          {{ siteDetail()?.address1 }} {{ siteDetail()?.address2 }}
        </p>
      </div>
    </header>

    @if (hasAlerts()) {
      <div class="bg-error-container text-on-error-container p-4 rounded-lg flex items-start gap-3">
        <mat-icon class="text-error mt-0.5">warning</mat-icon>
        <div>
          <h3 class="font-bold m-0">変位アラートが発生しています</h3>
          <ul class="mt-2 list-disc pl-5">
            @for (alert of alerts(); track alert.sensorId) {
              <li>
                {{ alert.sensorName }} (深度 {{ alert.depth }}m):
                {{ alert.axis }}軸の変位が過去1時間で {{ alert.displacementDiff | number:'1.1-2' }}mm 変化しました。
                (閾値: {{ alert.threshold }}mm) - {{ alert.timestamp | date:'shortTime' }}
              </li>
            }
          </ul>
        </div>
      </div>
    }

    <!-- Chart Section -->
    <mat-card class="elevation-1">
      <mat-card-header>
        <mat-card-title>傾斜変位量 (深度別)</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="p-6">
        @if (displacements().length > 0) {
          <app-tilt-displacement-chart [displacements]="displacements()" [alertThreshold]="alertThreshold()"></app-tilt-displacement-chart>
        } @else {
          <div class="flex flex-col items-center justify-center h-[400px] text-on-surface-variant">
            <mat-icon class="text-4xl mb-2 opacity-50">show_chart</mat-icon>
            <p>データがありません</p>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
